import { render, staticRenderFns } from "./ParkingSpacePage.vue?vue&type=template&id=5abb2fc6&scoped=true"
import script from "./ParkingSpacePage.vue?vue&type=script&lang=js"
export * from "./ParkingSpacePage.vue?vue&type=script&lang=js"
import style0 from "./ParkingSpacePage.vue?vue&type=style&index=0&id=5abb2fc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abb2fc6",
  null
  
)

export default component.exports